import React, { useEffect, useState } from "react";
import CreatorApp from "./struct";
import { FiMaximize } from "react-icons/all";
import Modal from 'react-modal'

const ModalAlert = ({modalIsOpen, closeModal}) => {
  return (<Modal
    isOpen={modalIsOpen}
    onRequestClose={closeModal}
    style={{
      overlay: {
        zIndex: 10000
      }
    }}
    contentLabel="Example Modal"
  >
    <h3>Uruchom kreator na urządzeniu o większej rozdzielczości.</h3>
  </Modal>)
}

function WithLoadProject(props) {
  const [scaling, setScaling] = useState(false)
  const [timer, setTimer] = useState(null)
  const [open, setOpen] = useState(false)

  const closeModal = () => setOpen(false)

  useEffect(() => {
    props.load()
  }, [])

  useEffect(() => {

    const resize = () => {
      setScaling(true)
      if(timer){
        clearTimeout(timer)
      }
      setTimer(setTimeout(() => setScaling(false), 400))
      if (window.screen.availWidth < 1280 && window.screen.availHeight < 800) {
        setOpen(true)
        // alert('Uruchom kreator na urządzeniu o większej rozdzielczości.')
      } else {
        setOpen(false)
      }
    }

    if (window.screen.availWidth < 1280 && window.screen.availHeight < 800) {
      setOpen(true)
      // alert('Uruchom kreator na urządzeniu o większej rozdzielczości.')
    } else {
      setOpen(false)
    }
    window.addEventListener('resize', resize)

    return () => {
      window.removeEventListener('resize', resize)
    }
  }, [timer, scaling])

  return <React.Fragment>
    {scaling && <div style={{
      width: '100vw',
      height: '100vh',
      opacity: 0.7,
      background: 'black',
      zIndex: 10000,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column'
    }}>
      <div style={{fontSize: 44}}>Skalowanie</div>
      <FiMaximize fontSize={64}/>
    </div>}
    <CreatorApp/>
    <ModalAlert modalIsOpen={open} closeModal={closeModal}/>
  </React.Fragment>
}

export default WithLoadProject



// WEBPACK FOOTER //
// ./src/screens/Creator/withLoadProject.js